import api from "./api";

export const sendProofOfDelivery = body =>
  api.post({
    path: "/message/email/template",
    body,
  });
